import { useQuery } from '@tanstack/react-query';
import { analyticsInterceptorV2 } from '../utils/Axios/analyticsInterceptorv2';

// The server caches /overview for cache_ttl_seconds (300); polling faster
// only returns the same payload, so we refetch on that interval.
const DEFAULT_TTL_MS = 300 * 1000;

const useFetchOverview = () => {
  const query = useQuery(
    ['analytics-overview'],
    async () => {
      const response = await analyticsInterceptorV2.get('/overview');
      return response.data;
    },
    {
      staleTime: DEFAULT_TTL_MS,
      refetchInterval: (data) =>
        data?.cache_ttl_seconds
          ? data.cache_ttl_seconds * 1000
          : DEFAULT_TTL_MS,
      refetchOnWindowFocus: false,
      // 403 means the user is not an admin; retrying will not help.
      retry: (failureCount, error) =>
        error?.response?.status !== 403 && failureCount < 1,
    }
  );

  return { ...query, errorStatus: query.error?.response?.status };
};

export default useFetchOverview;
